export default {
  // Login page
  login: "Вуруд",
  logout: "Берун равед",
  forgetPassword: "Рамзро фаромӯш кардаед?",
  toRegister: "Дохил шудан",
  UIN: "ИИН",
  step: "ҚАДАМ",
  step1: "IIN-и худро ворид кунед",
  step2:
    "Паролеро, ки шумо ҳангоми бақайдгирӣ сохтаед, ворид кунед. Агар шумо паролро дар хотир надоред, варианти 'Паролро фаромӯш кардаед?'",
  step3: 'Тугмаи "Вуруд" -ро зер кунед',
  "Неверный логин и/или пароль!": "Номи корбар ва / ё гузарвожаи нодуруст!",
  "A network error (such as timeout, interrupted connenction or unreachable host) has occured":
    "Хатогии шабака (ба монанди тамомшавии вақт, пайвасти қатъшуда ё соҳиби дастнорас) рух додааст",
  registration: "Сабти ном",
  BIN: "",
  phoneNumber: "Рақами телефон",
  back: "Бозгашт",
  next: "Оянда",
  requiredField: "Ҳатман талаб карда мешавад",
  enterEmail: "Email-ро ворид кунед",
  enterValidEmail: "Лутфан як почтаи мӯътабар ворид кунед",
  enterUINorBIN: "IIN / BIN-ро ворид кунед",
  chooseTaxOrgan: "Як мақоми андозро интихоб кунед",
  UINLength: "IIN / BIN аз 12 аломат иборат аст",
  serieLength: "Серия бояд аз 5 аломат иборат бошад",
  VATLength: "Рақами ААИ бояд 7 аломат дошта бошад",
  enterPhone: "Телефонро ворид кунед",
  chooseTaxType: "Намуди андозро интихоб кунед",
  onlyLatin: "Танҳо аломатҳои англисӣ ",
  capitalizeRequired: "Ақаллан як ҳарфи калон",
  numberRequired: "Ақаллан як рақам",
  lengthSymbols: "ҳадди аққал 8 аломат",
  repeatPassword: "Паролро дубора ворид кунед",
  passwordDontMatch: "Паролҳо мувофиқ нестанд",
  Reports: "Гузориш медиҳад",
  // Profile page
  profilePage: "Саҳифаи шахсӣ",
  analyticsPage: "Таҳлил",
  supplyPage: "Захираҳо",
  "Add new product": "Иловаи Маҳсулоти нав",
  addProduct: "Иловаи маҳсулот",
  discountPage: "Захираҳо",
  purchasesPage: "Харид",
  salesPage: "Фурӯш",
  salesReportPage: "Адад фурӯхта",
  selectStorePage: "Мағозаҳо",
  cashboxPage: "Хонаи қуттӣ",
  employeesPage: "Коргарон",
  inventoriesPage: "Инвентаризация",
  fullname: "ФИО",
  legalAddress: "Суроғаи ҳуқуқӣ",
  VAT: "НДС",
  taxOrgan: "Мақомоти андоз",
  taxType: "Намуди андоз",
  store: "магазин",
  stores: "Мағозаҳо",
  storeName: "Номи мағоза",
  storeAddress: "Суроғаи мағоза",
  // AnalyticsPage
  dailyStatistic: "Омор барои рӯз",
  today: "имрӯз",
  yesterday: "дирӯз",
  sales: "Фурӯш",
  // SelectStorPage
  chooseStore: "Дӯконеро интихоб кунед",
  add: "Илова кунед",
  select: "Интихоб кунед",
  change: "Таҳрир кунед",
  delete: "Нест кардан",
  cancel: "Бекор кардан",
  create: "Эҷод кунед",
  save: "Сарфа",
  profit: "Фоида",
  averageCheck: "ср. чек",
  order1: "фармоиш",
  order2: "фармоиш",
  order3: "фармоиш",
  client1: "муштариён",
  client2: "муштарӣ",
  client3: "фармоишгар",
  total: "Ҳамагӣ",
  numDays: "рӯзҳо",
  month: "моҳ",
  numMonth: "мох",
  other: "Дигар",
  allSupplies: "Ҳамагӣ",
  barcode: "Штрих-код",
  supplyTitle: "Ном",
  priceSale: "Нарх\nфурӯш, тг",
  priceSale2: "Нархи фурӯш",
  stock: "Боқимонда",
  stockBalance: "Боқимонда\nдар саҳҳомӣ",
  searchWithBarcodeName: "Аз штрих-код ё ном ҷустуҷӯ кунед",
  searchWithName: "Ҷустуҷӯ аз рӯи маҳсулоти маҳсулот",
  pageWord: "стр.",
  unitsMeasuring: "Ед.изм.",
  unitsMeasuringStorage: "Ед.изм. дар саҳҳомӣ",
  discount: "Тахфиф",
  datePurchase: "Санаи харид",
  purchasesInfo: "Маълумот дар бораи харид",
  purchasePrice: "Нархи  \nхарид, тг",
  title: "Унвон",
  amountProduct: "Миқдори молҳо ",
  description: "Тавсифи",
  from: "Аз",
  to: "Ба",
  discountPercent: "Тахфиф, %",
  addDiscount: "Илова ҳиссаи",
  link: "пайванд",
  forOperators: "барои операторон",
  employe: "Коргар",
  totalPrice: "Ҳамагӣ\nарзиши, тг",
  note: "Эзоҳ ",
  purchasesSum: "Ҷамъшуда\n",
  cashboxId: "Рақами касса",
  saleId: "Рақами фурӯш",
  dateSale: "Санаи фурӯш",
  quantity: "Миқдори",
  price: "Нарх, тг",
  fiscalize: "маблағгузорӣ кардан",
  nameCashbox: "Номи дафтари қуттӣ",
  idCashbox: "Шиносномаи пули нақд",
  titleStore: "Номи мағоза",
  addressStore: "Суроғаи мағоза",
  state: "Ҳолати",
  fiscal: "Маблағгузорӣ",
  cashboxInfo: "Маълумоти кассавӣ",
  shiftInfo: "Маълумот Shift",
  idNumber: "Рақами мушаххас",
  factoryNumber: "Рақами силсилавӣ",
  serialNumber: "Рақами силсилавӣ",
  cashboxDescription: "Тавсифи кассаи нақдина",
  registrationNumber: "Рақами бақайдгирӣ",
  dateRegister: "Санаи бақайдгирӣ",
  wayEnterDiscount: "Роҳ барои ворид кардани тахфиф",
  defaultIndustry: "Намуди намоишии саноат",
  purchaseMode: "Усули 'харид'",
  markup: "Пардохти изофӣ",
  serviceCenter: "Маркази хизматрасонӣ",
  activationPackage: "Маҷмӯи пайвастшавӣ",
  modeOperation: "Тартиби кор",
  CRF: "OFD",
  confirmCode: "Рамзи тасдиқкунанда",
  switchedOn: "Дохил шудааст",
  switchedff: "Хомӯш",
  disconnected: "Қатъи",
  connected: "Дохил шудааст",
  isAbsent: "Бедарак аст",
  shiftNumber: "Рақами Shift",
  shiftOpening: "Кушодани Shift",
  cashOnHand: "Пули нақд",
  numberOfSales: "Шумораи фурӯш",
  returnSales: "Бозгашти фурӯш",
  cashSales: "Фурӯши нақд",
  cardSale: "Фурӯши корти кредитӣ",
  numberOfPurchases: "Шумораи харид",
  numberOfRefunds: "Шумораи баргардонидан",
  deposit: "Амонат",
  withdrawal: "Аз ҳисоб баровардан",
  sum: "Маблағ",
  numberOfDocuments: "Шумораи ҳуҷҷатҳо",
  shiftClosing: "Сменаи пӯшида",
  roles: "Ҳуқуқҳо",
  lastname: "Фамилия",
  middlename: "Номи миёна",
  firstname: "Ном",
  sendPassword: "Паролро фиристед",
  startInventory: "Ба инвентаризатсия шурӯъ кунед",
  pastInventory: "Инвентаризатсияи гузашта",
  dateStart: "Таърихи саршавӣ",
  dateEnd: "Санаи анҷом ",
  show: "Намоиш",
  edit: "Таҳрир кунед",
  toComplete: "Барои ба итмом расонидани",
  discountToProduct: "Пешбурди мол",
  titleProduct: "Номи маҳсулот",
  saveChanges: "Тағиротро захира кунед",
  createNewDiscount: "Захираи нав эҷод кунед",
  titleDiscount: "Номи саҳҳомӣ",
  product: "мол",
  find: "Барои ёфтан",
  enterProductName: "Номи маҳсулотро ворид кунед",
  addToDiscount: "Илова ба мубодила",
  createDiscount: "Эҷоди ҳиссаи",
  createPromotionalItem: "Маводи таблиғиро эҷод кунед",
  confirmDelete: "Тозакуниро тасдиқ кунед",
  fiscalized: "Маблағгузорӣ шудааст",
  notFiscalized: "Маблағгузорӣ нашуда бошад",
  AddingToCategory: "Илова ба Категория",
  AddToCategory: "Илова ба категория",
  yes: "Бале",
  no: "Не",
  enterStoreName: "Номи мағозаро ворид кунед",
  selectStorage: "Дӯконеро интихоб кунед",
  registerIdCashbox: "Рақами муоина",
  dataChange: "Тағири маълумот",
  notFoundPage: "Саҳифа ёфт нашуд",
  "In this section you can work with your cash registers, namely":
    "Дар ин бахш шумо метавонед бо мошинҳои назоратӣ - кассаҳо кор кунед:",
  "Create new cash desks": "Кассаҳои нави хазинадор созед",
  "Delete existing cash desks": "Кассаҳои мавҷудаи кассаро нест кунед",
  "Edit Title": "Унвони унвон",
  "Turn on / off cash desks": "Фурӯзон / хомӯш кардани кассаҳои нақдӣ",
  "Fiscalize cash registers": "Бақайдгирии хазинаҳоро маблағгузорӣ кунед",
  "In this section you can create, modify and delete stocks of your stores":
    "Дар ин бахш шумо метавонед захираҳои мағозаҳои худро эҷод, тағир диҳед ё нест кунед",
  "In this section you can": "Дар ин боб шумо метавонед:",
  "Add new employees to stores": "Ба мағозаҳо кормандони нав илова кунед",
  "Remove employees from stores": "Кормандонро аз мағозаҳо дур кунед",
  "Edit employee access levels": "Сатҳи дастрасии кормандонро таҳрир кунед",
  "Please note that to add an employee, his / her IIN and cell phone number are required":
    "Лутфан қайд намоед, ки барои иловаи корманд, рақами IIN ва рақами телефони мобилӣ лозим аст",
  "Conduct a new inventory": "Гузаронидани инвентаризатсияи нав",
  "View details of previous inventories": "Дидани тафсилоти захираҳои қаблӣ",
  "Link copied": "Истинод нусхабардорӣ карда шуд",
  "In the menu of a specific inventory you can":
    "Дар менюи инвентаризатсияи мушаххас шумо метавонед:",
  "Complete inventory at the end of the inventory":
    "Анҷом додани инвентаризатсия",
  "Delete inventory": "Таҷҳизотро нест кунед",
  "Export inventory": "Инвентаризатсияи содирот",
  "In this section you can see detailed information about the owner of this Smartkassa account":
    "Дар ин бахш шумо метавонед маълумоти муфассалро дар бораи соҳиби ин Smartkassa ҳисоб кунед..",
  Signature: "Имзои:",
  "Goods from the purchase": "Товары из закупки",
  "In this section you can observe the information on purchases, namely":
    "Дар ин бахш шумо метавонед маълумоти харидро мушоҳида кунед, албатта:",
  "Date of purchase": "Санаи харид",
  "The cashier who procured": "Хазиначӣ, ки хазиначиро харид кардааст",
  "Total cost": "Арзиши умумӣ",
  "Various purchase notes": "Қайдҳои гуногуни харид",
  "Click on the purchase you are interested in for more information":
    "Барои гирифтани маълумоти бештар дар бораи хариде, ки шумо таваҷҷӯҳ доред, клик кунед.",
  "Password sent to the specified number":
    "Рамз ба рақами нишондодашуда фиристода шудааст!",
  "Incorrect code entered": "Рамзи нодуруст ворид карда шудааст",
  "Enter code": "Рамзро ворид кунед",
  "Password recovery": "Барқароркунии парол",
  "Login/IIN": "Вуруд / IIN",
  "Enter the code sent to your number":
    "Рамзи ба рақами шумо фиристодашударо ворид кунед",
  "Confirm password": "Рамзро тасдиқ кунед",
  "Enter the correct code": "Рамзи дурустро ворид кунед",
  "In this section you can observe information on sales, namely":
    "Дар ин бахш шумо метавонед маълумотро оид ба фурӯш мушоҳида кунед, албатта:",
  "Date of sale": "Санаи фурӯш",
  "The cashier who conducted the sale": "Хазиначӣ, ки фурӯшро анҷом додааст",
  "Various sales notes": "Қайдҳои гуногуни фурӯш",
  "Click on the sale you are interested in for more information":
    "Барои маълумоти бештар дар бораи фурӯш, ки ба шумо маъқул аст, клик кунед.",
  "In this section you can observe detailed information about each sold product for a certain period, including":
    "Дар ин қисмат шумо метавонед маълумоти муфассалро дар бораи ҳар як маҳсулоти фурӯхташуда барои давраи муайян, аз ҷумла:",
  "Unit of measure": "Воҳиди ченак",
  "Total cost of goods": "Арзиши умумии мол",
  "Unit of measure in stock": "Воҳиди ченак дар саҳҳомӣ",
  "Enter the correct password code": "Рамзи дурусти паролро ворид кунед",
  "Choose a store, information about which you want to receive":
    "Дӯконеро интихоб кунед, ки дар бораи он шумо мехоҳед ба даст оред",
  "Create new stores": "Магазинҳои нав созед",
  "Edit store names and addresses": "Номҳо ва суроғаҳои мағозаро таҳрир кунед",
  "Delete existing stores": "Дӯкони мавҷударо нест кунед",
  "Shop Creation": "Таъсиси сех",
  "Select Storage Shop creation step 1 info":
    "Ном ва суроғаи мағозаро таъин кунед. Лутфан қайд намоед, ки шумо номи нуқтаи муайяни фурӯшро таъин мекунед (баъдтар шумо метавонед номро иваз кунед). Адрес бояд ба суроғае, ки ҳангоми бақайдгирӣ дар мақомоти андоз дода шудааст, мувофиқат кунад",
  "The address must match the address issued during registration with the tax authority":
    "Адрес бояд ба суроғае, ки ҳангоми бақайдгирӣ дар мақомоти андоз дода шудааст, мувофиқат кунад",
  "Cash desk creation": "Таъсиси кассаи нақдӣ",
  "Creation of the first cash desk Name the cashier and select the store in which it is located":
    "Таъсиси аввалин кассаи амонатӣ Кассаро номбар кунед ва мағозаро, ки дар он ҷойгир аст, интихоб кунед",
  "Cashbox name": "Номи дафтари қуттӣ",
  "Fiscalize cashbox": "Маблағгузории кассаи хазинавӣ",
  "Please note that if you have a physical cashier, you can Smartkassa in non-fiscal mode by printing checks through your physical cashier":
    "Лутфан қайд намоед, ки агар шумо кассаи ҷисмонӣ дошта бошед, шумо метавонед Smartkassa-ро бо усули ғайрисискӣ бо чоп кардани чек тавассути кассири ҷисмонӣ, ба даст оред.",
  "Prerequisites for Fiscalization": "Заминаҳои қарздиҳӣ:",
  "cash register must be registered with the tax authority":
    "мошини хазинадор бояд дар мақомоти андоз ба қайд гирифта шавад",
  "account on the Webkassa service (paid separately on the website wwwwebkassakz)":
    "ҳисоб дар хидмати Вебкасса (алоҳида дар вебсайти www.webkassa.kz пардохт мешавад)",
  "CRF account (paid separately on the website wwwoofdkz)":
    "Ҳисоби CRF (алоҳида дар вебсайти www.oofd.kz пардохт мешавад)",
  "To Fiscalize": "Маблағгузорӣ кунед",
  skip: "Гузаштан",
  "Create employee": "Таъсиси кормандон",
  "To register an employee, you need:": "Барои бақайдгирии корманд, шумо бояд:",
  "IIN employee and": "Корманди IIN ва",
  "employee's cell phone number This number will receive the employee password to log into the Smartkassa system":
    "рақами телефони мобилии корманд. Ин рақам пароли кормандро барои вуруд ба Smartkassa мегирад.",
  "Submit Code": "Рамзи пешниҳод кунед",
  "Password was sent to the specified number":
    "Рамз ба рақами нишондодашуда фиристода шуд",
  "In this section you can observe detailed information for each of the goods you have, namely":
    "Дар ин бахш, шумо метавонед маълумоти муфассалро дар бораи ҳар як маҳсулоте, ки шумо доред, мушоҳида кунед:",
  "Purchase price": "Нархи харид",
  "The total cost of the sale of goods": "Арзиши умумии фурӯши мол",
  "Setted discount": "Танзими тахфиф",
  "Click on a product for more information":
    "Барои маълумоти бештар ба маҳсулот клик кунед.",
  "Once you have added the stocks, add the good ones and click on the 'Add to stocks' item below":
    "Барои илова кардани маҳсулот ба таблиғот, маҳсулоти дилхоҳро интихоб кунед ва 'Илова ба таблиғот' -ро клик кунед, ва баъд рекламаи дилхоҳро интихоб кунед ё наверо эҷод кунед.",
  "Data not found": "Ягон маълумоте ёфт нашуд",
  "In storage": "Дар саҳҳомӣ:",
  new1: "Нав:",
  new2: "Нав:",
  new3: "Нав:",
  unitsMeasuringFull: "Воҳиди:",
  purchasePrice2: "Нархи харид: ",
  addUnitsMeasuring: "Воҳиди илова кунед",
  select2: "Интихоб кунед",
  selectUnitsMeasuring: "Воҳиди интихоб кунед",
  purchased: "Харида шудааст",
  value: "Арзиш",
  clear: "Тоза",
  apply: "Барои ба кор бурдани",
  "To add a filter, press Enter, then Apply":
    "Барои илова кардани филтр, Enterро пахш кунед, ва баъд Применить",
  "In this section you can observe information on purchases, sales and profits of a particular store or product":
    "Дар ин бахш шумо метавонед маълумотро дар бораи харид, фурӯш ва фоидаи ягон мағоза ё маҳсулоти мушаххас мушоҳида кунед.",
  titelInventory: "Номи ихтироъ",
  redirectInventory: "Саҳифаи ихтироъ",
  payAll: "ҳама пардохт",
  payAFew: "пардохт чанд",
  pay: "пардохт кунанд",
  fyscalized: "маблағгузорӣ карда шуд",
  nonFyscalized: "молиявӣ карда намешавад",
  extendsFor: "дароз карда шуд",
  duration: "давомнокии",
  months: "мох",
  all: "ҳама",
  drop: "хориҷ кунед",
  activeBy: "фаъол то",
  fyscalization: "фискализатсия",
  remainderOnStorage: "Тавозуни саҳмияҳо",
  remainder: "Саҳмияҳо",
  purchasePrice1: "Нархи харид",
  purchaseprice: "Нархи харид",
  salePrice1: "Иловаи аксҳо",
  saleprice: "Иловаи аксҳо",
  uploadPhotoes: "Суратҳоро бор кунед",
  "Export to Excel": "Cодирот ба excel",
  "New inventory": "Инвентаризатсияи нав",
  years: "соли чорй",
  weeks: "ҳафтаҳо",
  "select week": "ҳафтаро интихоб кунед",
  "select dates": "санаи интихоб кунед",
  year: "сол",
  checkNum: "Рақами санҷиш",
  AddChartToCompare: "барои муқоиса ҷадвал илова кунед",
  AddComparableChart: "ҷадвали муқоисашавандаро илова кунед",
  "Comparative graph for time periods of different lengths":
    "Графикаи муқоисавӣ барои давраҳои дарозии гуногун",
  "Comparative Line Chart": "Диаграммаи хати муқоисавӣ",
  January: "Январ",
  February: "Феврал",
  March: "Март",
  April: "Апрел",
  May: "Май",
  June: "Июн",
  July: "Июл",
  August: "Август",
  September: "Сентябр",
  October: "Октябр",
  November: "Ноябр",
  December: "Декабр",
  Monday: "Душанбе",
  Tuesday: "Сешанбе",
  Wednesday: "Чоршанбе",
  Thursday: "Панҷшанбе",
  Friday: "Ҷумъа",
  Saturday: "Шанбе",
  Sunday: "Якшанбе",
  "Trade negative": "Савдо манфӣ",
  name: "ном",
  nds: "НДС",
  accountInormation: "Маълумот дар бораи ҳисоб",
  companyInformation: "Маълумот дар бораи ширкат",
  dataOnAvailableStores: "Маълумот дар бораи мағозаҳои дастрас",
  organization: "Ташкилот",
  Login: "Логин",
  password: "парол",
  "Old password": "Пароли кӯҳна ворид кунед",
  "New password": "пароли нав ворид кунед",
  "Repeat new password": "Пароли навро такрор кунед",
  "Change password": "гузарвожаро иваз кунед",
  "Data loading": "Боркунии маълумот",
  Inventory: "Инвентаризация",
}
